var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("h3", { staticClass: "mt-2" }, [_vm._v("OTP VERIFICATION")]),
          _vm._v(" "),
          _c("b-img", { attrs: { src: _vm.img_change_password, width: "200" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-justify mt-4" }, [
        _c("p", [_vm._v(_vm._s(_vm.description))])
      ]),
      _vm._v(" "),
      _c("b-form-group", { attrs: { id: "otp-code" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.a,
              expression: "otp.a"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.a },
          on: {
            keyup: function($event) {
              _vm.changeTab(1)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "a", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.b,
              expression: "otp.b"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.b },
          on: {
            keyup: function($event) {
              _vm.changeTab(2)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "b", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.c,
              expression: "otp.c"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.c },
          on: {
            keyup: function($event) {
              _vm.changeTab(3)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "c", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.d,
              expression: "otp.d"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.d },
          on: {
            keyup: function($event) {
              _vm.changeTab(4)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "d", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.e,
              expression: "otp.e"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.e },
          on: {
            keyup: function($event) {
              _vm.changeTab(5)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "e", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp.f,
              expression: "otp.f"
            }
          ],
          staticClass: "otp",
          attrs: { maxlength: "1", type: "text" },
          domProps: { value: _vm.otp.f },
          on: {
            keyup: function($event) {
              _vm.changeTab(6)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.otp, "f", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "command-box text-center" }, [
        !_vm.expired
          ? _c("p", { staticClass: "mt-4 mb-4" }, [
              _vm._v("\n      Code is valid for\n      "),
              _c("span", {
                class: { red: _vm.t_minute == 0 },
                domProps: { innerHTML: _vm._s(_vm.t_minute) }
              }),
              _vm._v(" "),
              _c("span", { class: { red: _vm.t_minute == 0 } }, [_vm._v(":")]),
              _vm._v(" "),
              _c("span", {
                class: { red: _vm.t_minute == 0 },
                domProps: { innerHTML: _vm._s(_vm.t_second) }
              }),
              _vm._v(" minutes.\n    ")
            ])
          : _c("p", { staticClass: "mt-4 mb-1" }, [
              _c("span", { staticClass: "red" }, [
                _vm._v("The code you received has expired,")
              ]),
              _vm._v("\n      please enter a new code.\n    ")
            ]),
        _vm._v(" "),
        _vm.expired
          ? _c("p", [
              _c("span", { staticClass: "text-shadow" }, [
                _vm._v("Didn't receive code?\n        "),
                _c(
                  "a",
                  {
                    staticClass: "text-primary resend",
                    on: { click: _vm.resendNow }
                  },
                  [_vm._v("Resend a new code")]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pull-right text-right mb-2" },
        [
          _c(
            "b-button",
            {
              staticClass: "btn gray m__t--15",
              on: {
                click: function($event) {
                  _vm.$emit("close-modal")
                }
              }
            },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btn blue m__t--15",
              attrs: {
                disabled: _vm.enable_verify > 5 && !_vm.expired ? false : true
              },
              on: { click: _vm.sendNow }
            },
            [_vm._v("\n      Verify\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39674316", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39674316","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/jInputOtp.vue
// module id = null
// module chunks = 